import './App.css';
import 'bootswatch/dist/quartz/bootstrap.min.css';
import PoetBot from './PoetBot';

function App() {
  return (
    <div className="App container">
      <PoetBot />
    </div>
  );
}

export default App;
